<template>
	<j-card class="mb2">
		<j-accordion colorWhenClosed="bg0">
			<div slot="title" class="fs4 fw7">{{ sectionTitle }}</div>
			<!-- Credentials (root) -->
			<data-list
				slot="body"
				:list="componentProps.root.list"
				v-on="componentHandlers"
			/>

			<!-- Contacts -->
			<data-list
				:label="$t('contact')"
				slot="body"
				:list="componentProps.contacts.list"
				v-on="componentHandlers"
			>
				<j-button
					v-if="showButtons"
					type="tertiary"
					size="small"
					slot="label"
					@click="$emit('contact:add')"
					>{{ $t("add_contact") }}</j-button
				>
			</data-list>

			<!-- Addresses -->
			<data-list
				:label="$t('addresses')"
				slot="body"
				:list="componentProps.addresses.list"
				v-on="componentHandlers"
			>
				<j-button
					v-if="showButtons"
					type="tertiary"
					size="small"
					slot="label"
					@click="$emit('address:add')"
					>{{ $t("add_address") }}</j-button
				>
			</data-list>

			<!-- Identities -->
			<data-list
				:label="$t('identities')"
				slot="body"
				:list="componentProps.identities.list"
				v-on="componentHandlers"
			>
				<j-button
					v-if="showButtons"
					type="tertiary"
					size="small"
					slot="label"
					@click="$emit('identity:add')"
					>{{ $t("add_identity") }}</j-button
				>
			</data-list>

			<!-- Facts -->
			<data-list
				:label="$t('facts')"
				slot="body"
				:list="componentProps.facts.list"
				v-on="componentHandlers"
			>
				<j-button
					v-if="showButtons"
					type="tertiary"
					size="small"
					slot="label"
					@click="$emit('fact:add')"
					>{{ $t("add_fact") }}</j-button
				>
			</data-list>

			<div
				slot="body"
				v-if="removable && showButtons"
				class="xs-12 flex xs-right xs-middle p2"
			>
				<j-button type="error" size="xsmall" @click="$emit('remove:section')"
					>{{ $t("remove") }} {{ sectionTitle }}</j-button
				>
			</div>
		</j-accordion>
	</j-card>
</template>

<script>
import JCard from "@/components/JCard"
import JAccordion from "@/components/JAccordion"
import JButton from "@/components/JButton"
import DataList from "../../DataList"

export default {
	name: "SectionEntity",
	components: {
		JCard,
		JAccordion,
		DataList,
		JButton
	},
	props: {
		componentProps: {
			type: Object
		},
		componentHandlers: {
			type: Object
		},
		sectionTitle: {
			type: String
		},
		removable: {
			default: false
		},
		showButtons: {
			required: false,
			default: true
		}
	},

	methods: {}
}
</script>
